import React, { useState, useEffect } from 'react';
import { Card, Button, Form, Input, Switch, message, Tabs } from 'antd';
import { UserOutlined, LockOutlined, BellOutlined, SettingOutlined } from '@ant-design/icons';
import { userAPI } from '../services/api';

const { TabPane } = Tabs;

const Settings = () => {
  const [form] = Form.useForm();
  const [notificationEnabled, setNotificationEnabled] = useState(true);
  const [loading, setLoading] = useState(false);

  // 从localStorage获取当前用户信息
  useEffect(() => {
    const userInfoStr = localStorage.getItem('userInfo');
    if (userInfoStr) {
      const userInfo = JSON.parse(userInfoStr);
      form.setFieldsValue({
        username: userInfo.username,
        phone: userInfo.phone,
        open_id: userInfo.open_id
      });
    }
  }, [form]);

  // 处理个人设置提交
  const handlePersonalSubmit = async (values) => {
    setLoading(true);
    try {
      const userInfoStr = localStorage.getItem('userInfo');
      if (userInfoStr) {
        const userInfo = JSON.parse(userInfoStr);
        await userAPI.updateUser(userInfo.id, values);
        message.success('个人设置更新成功');
        
        // 更新localStorage中的用户信息
        const updatedUserInfo = { ...userInfo, ...values };
        localStorage.setItem('userInfo', JSON.stringify(updatedUserInfo));
      }
    } catch (error) {
      console.error('更新个人设置错误:', error);
      message.error('更新个人设置失败');
    } finally {
      setLoading(false);
    }
  };

  // 处理密码更新
  const handlePasswordSubmit = async (values) => {
    setLoading(true);
    try {
      const userInfoStr = localStorage.getItem('userInfo');
      if (userInfoStr) {
        const userInfo = JSON.parse(userInfoStr);
        // 调用API更新密码
        await userAPI.updateUser(userInfo.id, {
          password: values.newPassword
        });
        message.success('密码更新成功');
        form.resetFields();
      }
    } catch (error) {
      console.error('更新密码错误:', error);
      message.error('更新密码失败');
    } finally {
      setLoading(false);
    }
  };

  // 处理通知设置变更
  const handleNotificationChange = (checked) => {
    setNotificationEnabled(checked);
    message.info(`通知已${checked ? '开启' : '关闭'}`);
  };

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 className="glass-page-title">设置</h1>
      </div>

      <div>
        {/* 个人设置 */}
        <Card className="glass-card" title="个人信息" style={{ marginBottom: 24 }}>
          <Form
            form={form}
            className="glass-form"
            layout="vertical"
            onFinish={handlePersonalSubmit}
          >
            <Form.Item
              name="username"
              label="用户名"
              rules={[{ required: true, message: '请输入用户名' }]}
            >
              <Input prefix={<UserOutlined />} />
            </Form.Item>
            
            <Form.Item
              name="phone"
              label="手机号"
              rules={[{ required: true, message: '请输入手机号' }, { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的中国手机号' }]}
            >
              <Input />
            </Form.Item>
            
            <Form.Item
              name="open_id"
              label="飞书OpenID"
              rules={[{ max: 50, message: '飞书OpenID长度不能超过50个字符' }]}
            >
              <Input placeholder="请输入飞书OpenID（可选）" />
            </Form.Item>
            
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading}>
                保存个人设置
              </Button>
            </Form.Item>
          </Form>
        </Card>

        <Card className="glass-card" title="密码设置" style={{ marginBottom: 24 }}>
          <Form
            className="glass-form"
            layout="vertical"
            onFinish={handlePasswordSubmit}
          >
            <Form.Item
              name="currentPassword"
              label="当前密码"
              rules={[{ required: true, message: '请输入当前密码' }]}
            >
              <Input.Password prefix={<LockOutlined />} />
            </Form.Item>
            
            <Form.Item
              name="newPassword"
              label="新密码"
              rules={[{ required: true, message: '请输入新密码' }, { min: 6, message: '密码长度至少为6位' }]}
            >
              <Input.Password prefix={<LockOutlined />} />
            </Form.Item>
            
            <Form.Item
              name="confirmPassword"
              label="确认新密码"
              rules={[
                { required: true, message: '请确认新密码' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('两次输入的密码不一致'));
                  }
                })
              ]}
            >
              <Input.Password prefix={<LockOutlined />} />
            </Form.Item>
            
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading}>
                更新密码
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default Settings;
